import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = () => (_jsxs("svg", { fill: "none", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round", viewBox: "0 0 24 24", children: [_jsx("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }), _jsx("circle", { cx: 12, cy: 12, r: 3 })] }));
export default SvgComponent;
